import React, { useState, useEffect } from "react";

export const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewbox="0 0 20 20" fill="currentColor"><path d="M17.012 6.507v-.002c-.662 0-1.272.24-1.76.643-1.202-.8-2.7-1.31-4.333-1.455.048-.704.259-1.227.664-1.568.403-.34.967-.485 1.493-.534.329.429.84.71 1.423.71a1.8 1.8 0 1 0-1.664-2.484c-.785.08-1.675.315-2.403.923-.82.686-1.244 1.688-1.305 2.95-1.65.142-3.161.657-4.374 1.465a2.75 2.75 0 0 0-1.766-.648C1.393 6.506.1 7.896.1 9.61c0 1.244.68 2.316 1.663 2.812.095 3.604 3.749 6.504 8.244 6.504s8.153-2.903 8.244-6.51c.975-.5 1.649-1.567 1.649-2.804 0-1.715-1.293-3.105-2.888-3.105v-.001zm-.534 4.793-.027 1.07c-.066 2.622-2.957 4.755-6.444 4.755s-6.375-2.131-6.444-4.751l-.03-1.075-.96-.484c-.41-.206-.673-.68-.673-1.204 0-.72.488-1.305 1.088-1.305.278 0 .487.126.614.232l1.032.859 1.118-.745C6.79 7.959 8.07 7.547 9.455 7.458l.993-.013c1.419.074 2.735.489 3.807 1.202l1.114.74 1.03-.852a.97.97 0 0 1 .55-.228h.062c.6 0 1.088.585 1.088 1.305 0 .522-.263.994-.67 1.202z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
